var _defs, _path, _circle, _circle2, _path2, _path3, _circle3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnnualTaxSettlement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Vrstva_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 198.4 198.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_0_69bf4e7cb76fd7c61ccf0730cd4fc5f1f6995687b7ee00a4a5bab1c05b80140d",
    x1: 67.2,
    y1: 123,
    x2: 79.4,
    y2: 123,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7a0399"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b10372"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_69bf4e7cb76fd7c61ccf0730cd4fc5f1f6995687b7ee00a4a5bab1c05b80140d",
    x1: 67.7,
    y1: 131.2,
    y2: 131.2,
    xlinkHref: "#SVGID_0_69bf4e7cb76fd7c61ccf0730cd4fc5f1f6995687b7ee00a4a5bab1c05b80140d"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_69bf4e7cb76fd7c61ccf0730cd4fc5f1f6995687b7ee00a4a5bab1c05b80140d",
    x1: 72,
    y1: 115.2,
    x2: 74.6,
    y2: 115.2,
    xlinkHref: "#SVGID_0_69bf4e7cb76fd7c61ccf0730cd4fc5f1f6995687b7ee00a4a5bab1c05b80140d"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_69bf4e7cb76fd7c61ccf0730cd4fc5f1f6995687b7ee00a4a5bab1c05b80140d",
    x1: 72.1,
    y1: 135.3,
    x2: 74.6,
    y2: 135.3,
    xlinkHref: "#SVGID_0_69bf4e7cb76fd7c61ccf0730cd4fc5f1f6995687b7ee00a4a5bab1c05b80140d"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M55.9 109.8V21.7H141v114.5H89.4"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "MI_4L_stroke",
    cx: 119.1,
    cy: 102.4,
    r: 2.3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "MI_4L_stroke",
    cx: 127.8,
    cy: 112.1,
    r: 2.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_stroke",
    d: "M117.4 114.3l12.2-14.3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M60.5 109.8H43.9c-1.2 0-2.2 1-2.2 2.2v5.8c0 1.2 1 2.2 2.2 2.2h10.3M54.4 130.3H43.8c-1.2 0-2.2 1-2.2 2.2v5.8c0 1.2 1 2.2 2.2 2.2h17.7M54.2 120.1H40.3c-1.2 0-2.2 1-2.2 2.2v5.8c0 1.2 1 2.2 2.2 2.2h14.1"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "MI_4L_main",
    cx: 73.3,
    cy: 124.8,
    r: 19.7
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_gradient",
    d: "M77.7 121.6s-.8-4.5-4.5-4.5-4.7 4.5-4.7 4.5l9.7 7.3",
    stroke: "url(#SVGID_0_69bf4e7cb76fd7c61ccf0730cd4fc5f1f6995687b7ee00a4a5bab1c05b80140d)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st1 MI_4L_gradient",
    d: "M68.9 128.9s.8 4.5 4.5 4.5 4.7-4.5 4.7-4.5",
    stroke: "url(#SVGID_1_69bf4e7cb76fd7c61ccf0730cd4fc5f1f6995687b7ee00a4a5bab1c05b80140d)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0 MI_4L_gradient",
    stroke: "url(#SVGID_2_69bf4e7cb76fd7c61ccf0730cd4fc5f1f6995687b7ee00a4a5bab1c05b80140d)",
    d: "M73.3 113.2v3.9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st2 MI_4L_gradient",
    stroke: "url(#SVGID_3_69bf4e7cb76fd7c61ccf0730cd4fc5f1f6995687b7ee00a4a5bab1c05b80140d)",
    d: "M73.3 133.4v3.8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M65.5 37.6h24.6M65.5 46.6h37.8M65.5 61.7h37.8M121.5 61.7h9.8M65.5 69.2h37.8M121.5 69.2h9.8M65.5 76.7h37.8M121.5 76.7h9.8M65.5 84.3h37.8M121.5 84.3h9.8"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_stroke",
    d: "M65.5 91.8h65.8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnnualTaxSettlement);
export default __webpack_public_path__ + "static/media/annualTaxSettlement.992cd27993486276279f73edecb585b7.svg";
export { ForwardRef as ReactComponent };